// extracted by mini-css-extract-plugin
module.exports = {"logoCellphone":"Layout_logoCellphone__2C0_6","navbar-toggler":"Layout_navbar-toggler__3tovP","logo":"Layout_logo__2wzNQ","homeOption":"Layout_homeOption__2UHfI"};